import interceptor from '@/plugins/interceptor';
const pathExternalData = '/ExternalData.aspx?'

export default {
    state: () => ({
        userData: {},
		viewData: {},
        tokenHash: '', 
        rukyExternalToken: {}
    }),
    getters: {
        externalData_viewData: state => state.viewData,
        externalData_userData: state => state.userData,
        externalData_tokenHash: state => state.tokenHash,
        externalData_rukyExternalToken: state => state.rukyExternalToken
    },
    mutations: { 
        SET_USER_DATA(state, payload) {
			state.userData = payload;
		},
		SET_VIEW_DATA(state, payload) {
			state.viewData = payload;
		},
        SET_TOKEN_HASH(state, payload) {
			state.tokenHash = payload;
		},
        SET_RUKY_EXTERNAL_TOKEN(state, payload) {
			state.rukyExternalToken = payload;
		}
    },
    actions: {
        async forgeAuth_loadData({ commit }) {
            const key = interceptor.getParameterByName(
				"cookie",
				window.location.href
			);
            if(typeof(process.env.VUE_APP_DASHDEBUG) != 'undefined' && process.env.VUE_APP_DASHDEBUG == 'ENABLED')
            {
                commit("SET_USER_DATA", {"id":44,"name":"Julieta","firstname":"Julieta","lastname":"Amessa","token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiI0NCIsInVzZXJuYW1lIjoic2JyaWdub25pIiwiZXh0ZXJuYWxVc2VyIjoiVHJ1ZSIsIm5iZiI6MTc1MjE2NzUzMCwiZXhwIjoxNzU0NzU5NTMwLCJpYXQiOjE3NTIxNjc1MzB9.UfdHWFF-Car08TnIqcJuMJ5YzOk4z89ebEfISLZVJJI.nXoU4lS-GwgnhfUEDMTEFep6vGY7_4YBk2NIjJjBEIo"});
                commit("SET_VIEW_DATA", []);
            }
            else
            {
                const userData = await interceptor.anonymous.getBackend(`${process.env.VUE_APP_API_BACKEND_URL}${pathExternalData}type=userdata`);
                commit("SET_USER_DATA", userData.data.data);
                interceptor.externalToken = userData.data.data.token;
                const viewData = await interceptor.anonymous.getBackend(`${process.env.VUE_APP_API_BACKEND_URL}${pathExternalData}type=cookie&key${key}`);
                commit("SET_VIEW_DATA", viewData.data.data);
            }
        },
        async forgeAuth_authRuky({ commit, state }) {

            let tokenHashData = null;
            if(typeof(process.env.VUE_APP_DASHDEBUG) != 'undefined' && process.env.VUE_APP_DASHDEBUG == 'ENABLED')
            {
                tokenHashData = await interceptor.anonymous.get(`${process.env.VUE_APP_API_BACKEND_API_URL}/common/rukyTokenById/${44}`);
                
            }
            else
            {
                tokenHashData = await interceptor.external.get(`${process.env.VUE_APP_API_BACKEND_API_URL}/common/rukyToken`,state.userData.token);
            }            

            commit("SET_TOKEN_HASH", tokenHashData.data.rukyHashToke);
            state.userData.id = tokenHashData.data.tutorId
            interceptor.tokenHash = tokenHashData.data.rukyHashToke;
            const rukyExternalToken = await interceptor.anonymous.post(`${process.env.VUE_APP_API_SECURITY_URL}/Security/forge/authenticate`,{ token:interceptor.tokenHash });
            commit("SET_RUKY_EXTERNAL_TOKEN", rukyExternalToken.data);
            interceptor.rukyExternalToken = rukyExternalToken.data.token
        }
    }
}
